import api from "./axios";

export const getIntroImage = async (
): Promise<Blob> => {
  const response = await api.get<Blob>("/intro/image", {
    responseType: "blob"
  });
  return response.data;
};
